import { AppState } from '@Redux/store';
import { ArmyList } from '@Models';

export const getArmyLists = (state: AppState, props: any): Array<ArmyList> => {
  return (
    state.armyLists.entity?.filter(
      (item) =>
        (item.folderId == null && props.parentId == null) ||
        item.folderId === props.parentId,
    ) ?? []
  );
};
